<template>
  <div
    class="zj-layout-main-content bgcolor scrollable"
    style="overflow: auto;"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">线路管理详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <!-- prop="ResourceName" -->
      <zj-layout-main>
        <el-form
          ref="form"
          :model="data"
          :rules="rules"
          label-width="16rem"
          style="width: 80%;"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="线路编号" prop="LineId">
                <el-input v-model="data.LineId" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="线路名称" prop="LineName">
                <el-input
                  v-model="data.LineName"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="上行首班时间" prop="UpFrist">
                <el-input v-model="data.UpFrist" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="上行发车间隔" prop="UpInterval">
                <el-input
                  v-model="data.UpInterval"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <div style="padding-top:1rem;">分钟</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="上行总里程" prop="UpMil">
                <el-input v-model="data.UpMil" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <div style="padding-top:1rem;">公里</div>
            </el-col>

            <el-col :span="11">
              <el-form-item label="上行运行时长" prop="UpTime">
                <el-input v-model="data.UpTime" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <div style="padding-top:1rem;">分钟</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="上行末班时间" prop="UpLast">
                <el-input v-model="data.UpLast" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="下行首班时间" prop="DownFrist">
                <el-input
                  v-model="data.DownFrist"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="下行发车间隔" prop="DownInterval">
                <el-input
                  v-model="data.DownInterval"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <div style="padding-top:1rem;">分钟</div>
            </el-col>
            <el-col :span="11">
              <el-form-item label="下行总里程" prop="DownMil">
                <el-input v-model="data.DownMil" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <div style="padding-top:1rem;">公里</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="下行运行时长" prop="DownTime">
                <el-input
                  v-model="data.DownTime"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <div style="padding-top:1rem;">分钟</div>
            </el-col>
            <el-col :span="12">
              <el-form-item label="下行末班时间" prop="DownLast">
                <el-input
                  v-model="data.DownLast"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注" prop="Expend1">
                <el-input
                  v-model="data.Expend1"
                  :disabled="!IsEdit"
                  type="textarea"
                  :autosize="{ minRows: 2 }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-form-item class="right" style="width:134rem;">
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="saveForm()"
          :disabled="!IsEdit"
          v-if="IsEdit"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";

export default {
  name: "LineManagerInfo",
  controller: "UI",
  action: "LineManagerInfo",
  data() {
    return {
      data: {},
      IsEdit: false,
      rules: {
        LineId: [
          { required: true, message: "请输入线路编号", trigger: "blur" },
        ],
        LineName: [
          { required: true, message: "请输入线路名称", trigger: "blur" },
        ],
        DeviceType: [
          { required: true, message: "请选择车船类型", trigger: "change" },
        ],
        UpInterval: [
          {
            required: false,
            message: "上行发车间隔必须为正整数",
            trigger: "blur",
            pattern: /^(0|[1-9]\d*)$/,
          },
        ],
        UpMil: [
          {
            required: false,
            message: "上行总里程必须为数字",
            trigger: "blur",
            pattern: /^(-?[0-9]+)(\.[0-9]+)?$/,
          },
        ],
        UpTime: [
          {
            required: false,
            message: "上行运行时长必须为数字",
            trigger: "blur",
            pattern: /^(-?[0-9]+)(\.[0-9]+)?$/,
          },
        ],
        DownInterval: [
          {
            required: false,
            message: "下行发车间隔必须为正整数",
            trigger: "blur",
            pattern: /^(0|[1-9]\d*)$/,
          },
        ],
        DownMil: [
          {
            required: false,
            message: "下行总里程必须为数字",
            trigger: "blur",
            pattern: /^(-?[0-9]+)(\.[0-9]+)?$/,
          },
        ],
        DownTime: [
          {
            required: false,
            message: "下行运行时长必须为数字",
            trigger: "blur",
            pattern: /^(-?[0-9]+)(\.[0-9]+)?$/,
          },
        ],
      },
    };
  },
  created: function() {
    if (this.$route.query.InfoId) {
      this.search();
    }
    if (this.$route.query.type == "query") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
  },
  watch: {
    $route: function() {
      if (this.$route.query.InfoId) {
        this.search();
      }
    },
  },
  methods: {
    search() {
      let InfoId = this.$route.query.InfoId;
      if (InfoId) {
        let searchInfo = {
          ID: InfoId,
        };
        new MyApis.LinesApi()
          .GeItemById(searchInfo)
          .then((r) => {
            r = r.data.Data;
            this.data = r;
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //保存
    saveForm() {
      const that = this;
      that.$refs.form.validate((valid) => {
        if (valid) {
          that.GetCarShipLines(function(data) {
            if (!data) {
              that.saveData();
            }
          });
        } else {
          return false;
        }
      });
    },
    //检验是否有重复记录
    GetCarShipLines(callback) {
      let searchInfo = {
        PageSize: 100000000,
      };
      let isExistEntity = false;
      new MyApis.LinesApi()
        .GetItemPagingList(searchInfo)
        .then((r) => {
          r = r.data.Data;
          const result = r.PageContents;
          if (result != null) {
            if (this.$route.query.type == "edit") {
              const index = result.findIndex(
                (p) =>
                  (p.LineName == this.data.LineName ||
                    p.LineId == this.data.LineId) &&
                  p.ID != this.data.ID
              );
              if (index > -1) {
                this.$message.error("线路编码或名称已存在，请重新输入！");
                isExistEntity = true;
              }
            } else {
              const index = result.findIndex(
                (p) =>
                  p.LineName == this.data.LineName ||
                  p.LineId == this.data.LineId
              );
              if (index > -1) {
                this.$message.error("线路编码或名称已存在，请重新输入！");
                isExistEntity = true;
              }
            }
          }
          callback(isExistEntity);
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    saveData() {
      let uuid = "";
      if (this.$route.query.type == "edit") {
        uuid = this.$route.query.InfoId;
      } else {
        uuid = ZJApp.ZJUtils.uuid();
      }
      if (this.$route.query.type == "edit") {
        //编辑
        this.data.ModifyTime = new Date();
        this.data.Modifier = ZJApp.ZJUser.current.UserName;
        let formAll = JSON.stringify(this.data);
        formAll = JSON.parse(formAll);
        new MyApis.LinesApi()
          .UpdateItem(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "线路修改";
            this.logInfo.LogMessage = r ? "线路修改成功" : "线路修改失败";
            this.logInfo.ModuleName = "车辆调度";
            this.logInfo.PageName = "线路管理详情";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      } else {
        // 增加
        let formObj = {
          Creater: ZJApp.ZJUser.current.UserName,
          CreateTime: new Date(),
          Modifier: ZJApp.ZJUser.current.UserName,
          ModifyTime: new Date(),
          Validity: 1, //新增编辑是1，删除是0
          ID: uuid,
        };
        let formAll = Object.assign(formObj, this.data);
        formAll = JSON.stringify(formAll);
        formAll = JSON.parse(formAll);
        new MyApis.LinesApi()
          .AddItem(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "线路添加";
            this.logInfo.LogMessage =  r ? "线路添加成功" : "线路添加失败";
            this.logInfo.ModuleName = "车辆调度";
            this.logInfo.PageName = "线路管理详情";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
  },
};
</script>
